import { SanityProductCategoryName } from './sanity-product-category-name.enum';

export const AccessoriesSanityProductCategoryNames = [SanityProductCategoryName.TOTE_BAGS];
